// ============================================================================
// BonBoZ: gạn thanh điều hướng trái.
//
// Chatwoot dựng sẵn cho mọi kiểu khách hàng — web chat, SMS, WhatsApp, help
// center, trợ lý AI, hoá đơn. BonBoZ chỉ trực hai page Facebook, nên quá nửa
// thanh trái là những mục không bao giờ bấm tới. Người trực page phải lướt qua
// chúng mỗi lần tìm một hội thoại.
//
// ẨN, KHÔNG XOÁ: mọi mục vẫn còn nguyên trong code và route vẫn vào được bằng
// URL. Cần dùng lại thì bỏ tên khỏi danh sách dưới đây, không phải sửa gì thêm.
//
// Tên dùng ở đây là trường `name` trong `menuItems` của
// `components-next/sidebar/Sidebar.vue` — cố tình dùng `name` chứ không dùng
// nhãn hiển thị, vì nhãn đổi theo ngôn ngữ.
// ============================================================================

const MUC_AN = new Set([
  // --- mục chính ---
  'Inbox', // hộp thông báo @mention; đội trực nhỏ, đã có Mentions trong Hội thoại
  'Captain', // trợ lý AI của Chatwoot, chưa mua và chưa cấu hình
  'Companies', // phòng khám bán cho người, không bán cho công ty
  'Campaigns', // chiến dịch Live chat/SMS/WhatsApp — không có kênh nào trong số đó
  'Portals', // help center, không dùng
  'Calls', // tổng đài trong Chatwoot; phòng khám gọi bằng Callio
  'Contacts', // trực page làm việc theo hội thoại, hồ sơ khách xem ở panel phải

  // --- lọc hội thoại ---
  'Participating', // trùng vai trò với "Đã gán cho tôi", đội trực nhỏ không cần

  // --- đã có menu riêng ngay trong trang, thanh trái không cần nữa ---
  'Reports',
  'Settings',

  // Nhóm "Hội thoại" của Chatwoot: TRÙNG hẳn với cụm nút lọc nhanh bên trên
  // (Tất cả / Nhắc tôi / Chưa xử lý...), để cả hai thì thanh trái có hai hệ
  // lọc song song, bấm cái nào cũng ra kết quả gần giống nhau mà không ai
  // hiểu khác nhau chỗ nào. Lọc theo Nhãn và theo Kênh đã có ở lưới tag và ô
  // chọn trang ngay trên danh sách.
  'Conversation',

  // --- thống kê ---
  'Reports CSAT', // chưa bật khảo sát hài lòng
  'Reports SLA', // chưa đặt cam kết thời gian phản hồi
  'Reports Bot', // chưa có bot

  // --- cài đặt ---
  'Settings Billing', // bản tự dựng, không có hoá đơn
  'Settings Sla',
  'Settings Custom Roles', // vai trò tuỳ biến của bản trả phí
  'Conversation Workflow',
]);

/**
 * Lọc đệ quy cây menu. Mục cha mà lọc xong không còn con nào thì ẩn luôn —
 * để lại một mục bấm vào không ra gì còn khó hiểu hơn là không có.
 */
export function locMucSidebar(muc) {
  return muc.reduce((giu, m) => {
    if (MUC_AN.has(m.name)) return giu;
    if (Array.isArray(m.children)) {
      const con = locMucSidebar(m.children);
      if (!con.length) return giu;
      giu.push({ ...m, children: con });
    } else {
      giu.push(m);
    }
    return giu;
  }, []);
}

// Đang đứng trong phần HỘI THOẠI không? (cùng bộ tiền tố với thanh trên —
// ThanhTren.vue). Dùng cho những thứ chỉ có nghĩa cạnh danh sách hội thoại,
// ví dụ cột lọc nhanh: sang Thống kê/Cài đặt mà còn treo bộ lọc "Chưa phản
// hồi, Của tôi..." thì chỉ gây rối.
const DUONG_HOI_THOAI =
  /\/app\/accounts\/\d+\/(dashboard|conversations|inbox|team|label|mentions|unattended|folder|custom_view)/;

export function dangOPhanHoiThoai(path) {
  return DUONG_HOI_THOAI.test(path);
}
